<template>
	<div>
		<div
			v-for="(chunk, chunkIndex) in displayedChunks"
			:key="chunkIndex"
			class="flex gap-3 md:gap-4"
			:class="{'text-body-important': chunk[0].isHoliday}"
		>
			<template v-if="isClosed">
				<strong class="font-normal min-w-[1.25rem] md:min-w-[1.7rem]">
					{{ formatChunkDays(chunk, !!useFullDayName) }}
				</strong>
				<span class="mb-1 md:mb-4">Zavřeno</span>
			</template>
			<template v-else>
				<strong v-if="!showToday" class="font-normal min-w-[1.25rem] md:min-w-[1.7rem]">
					{{ formatChunkDays(chunk, !!useFullDayName) }}
				</strong>
				<ul v-if="chunk[0].isOpen" class="flex gap-3 md:gap-4">
					<li
						v-for="(range, rangeIndex) in chunk[0].hours"
						:key="rangeIndex"
						class="mb-1 md:mb-4"
					>
						{{ formatHourRange(range) }}
					</li>
				</ul>
				<span v-else class="mb-1 md:mb-4">Zavřeno</span>
			</template>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {Plugin} from '@/types/openingHours';
	import type {HolidayOpeningHoursStoryblok} from '~/storyblok/types';
	import {parseOpeningHours, formatHourRange, formatChunkDays} from '~/utils/openingHours';

	interface Props {
		hours: Plugin
		holidays?: HolidayOpeningHoursStoryblok[]
		showToday?: boolean
		isClosed?: boolean
		useFullDayName?: boolean
	}

	const props = defineProps<Props>();

	const displayedChunks = computed(() => {
		const {today, chunks} = parseOpeningHours(props.hours.openingHours, props.holidays);
		return props.showToday ? [[today]] : chunks;
	});
  </script>
